import { cn } from "@gymflow/helpers";

export const HostedPagesProfileCard = {
  Container: ({
    children,
    className,
  }: {
    children: React.ReactNode;
    className?: string;
  }) => (
    <div
      className={cn(
        "shadow-xs bg-gray-0 flex justify-between gap-3 rounded-2xl border border-gray-200 p-3 dark:border-gray-800 dark:bg-gray-950",
        className,
      )}
    >
      {children}
    </div>
  ),
};
